export default "__VITE_ASSET__CPA_XSV0__"